import React, { useEffect, useState } from "react"
import AddMethodPaymentModal from "./AddPaymentMethodModal"
import PaymentCounts from "../PaymentModals/PaymentCounts"
import TableListMethod from "../../containers/Contacts/Table/PaymentMethod/TableListMethod"
import { useDispatch, useSelector } from "react-redux"
import { getBankPayment, getCardPayment } from "../../features/payment/paymentSlice"
import { showSnackBar } from "../Snackbar/Snackbar"
import { StorageGetItem, USER } from "../../lib/storage"
import { buildPaymentMethodRows } from "./paymentMethodRows"
import { useIsSupervisor } from "../../hooks/user"
import { selectFeatureFlag } from "../../features/featureFlags/selectors"


const PaymentMethodTab = ({ userId, userData, setTriggerUpdateSidebar }) => {
  const dispatch = useDispatch()
  const isSupervisor = useIsSupervisor()

  // THE ONLY READ OF THIS FLAG, and it is resolved here into the DATA the grid receives rather
  // than passed down as a flag. A NACHA hold is armed on the billing account and mirrored on the
  // CONTACT, and the mirror is the half that survives the disputed account being deleted — at
  // which point no row carries the hold, nothing on screen explains why the payments stopped, and
  // `Record authorization` cannot be reached at all. 912 contacts held a live mirror on
  // 2026-09-22, 42 of them with no account row carrying it.
  //
  // With the flag off the grid is handed `undefined`, which is indistinguishable from a contact
  // with no hold, so the OFF path is byte-for-byte the old behaviour.
  const contactBlockVisible = useSelector(selectFeatureFlag('CONTACT_DEBIT_BLOCK_VISIBLE'))

  // `userData` is fetched once per contactId by Contact.jsx and is not refreshed by this tab's
  // own reload, so once the grid has cleared a contact-level hold our copy of it is stale. Held
  // locally rather than re-fetching the whole contact: the only thing that changed is one
  // boolean, and widening Contact.jsx's fetch would re-run it for every tab that nudges the
  // sidebar.
  const [contactBlockCleared, setContactBlockCleared] = useState(false)
  useEffect(() => { setContactBlockCleared(false) }, [userData?.debitBlock?.blockedAt])

  const contactDebitBlock = contactBlockVisible && !contactBlockCleared
    ? (userData?.debitBlock || undefined)
    : undefined
  const [paymentCardMethod, setPaymentCardMethod] = React.useState([])
  const [paymentBankMethod, setPaymentBankMethod] = React.useState([])

  const [paymentMethod, setPaymentMethod] = React.useState([])
  const [userRole, setUserRole] = useState('')
  useEffect(() => {
    StorageGetItem(USER).then(result => {
      setUserRole(result?.role)
    })

  }, [])

  const fetchCardData = async () => {
    try {
      const cardPayment = await dispatch(getCardPayment(userId))
      setPaymentCardMethod(cardPayment?.payload?.data)
    } catch (error) {
      showSnackBar("error", error)
      console.error('An unexpected error occurred while fetching payment card data:', error)
    }
  }

  const fetchBankData = async () => {
    try {
      const bankPayment = await dispatch(getBankPayment(userId))
      setPaymentBankMethod(bankPayment?.payload?.data)
    } catch (error) {
      showSnackBar("error", error)
      console.error('An unexpected error occurred while fetching payment bank data:', error)
    }
  }

  const fetchData = async () => {
    try {
      await Promise.all([fetchCardData(), fetchBankData()])
      setTriggerUpdateSidebar(prev => !prev)
    } catch (error) {
      console.error('An unexpected error occurred while fetching payment data:', error)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
    setPaymentMethod(buildPaymentMethodRows({ cards: paymentCardMethod, banks: paymentBankMethod }))
  }, [paymentCardMethod, paymentBankMethod])

  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-between w-full mb-8">
        <div className="mx-5">
          <h5 className="mb-3 text-xl-20 font-bold">Payment Method</h5>
          {(userRole === 'customer' || isSupervisor) && <AddMethodPaymentModal triggerUpdate={fetchData}
                                                                               userId={userId}
                                                                               userData={userData} isLink={false}
                                                                               acceptedPaymentMethods={userData?.acceptedPaymentMethods}/>}

        </div>
        <PaymentCounts count={{ card: paymentCardMethod?.length, bank: paymentBankMethod?.length }}/>
      </div>

      <TableListMethod triggerUpdate={fetchData}
                       curUserId={userId}
                       data={paymentMethod}
                       userRole={userRole}
                       contactDebitBlock={contactDebitBlock}
                       onContactBlockCleared={() => setContactBlockCleared(true)}/>
    </div>
  )
}
export default PaymentMethodTab
